import styled from 'styled-components';
import { getCombinedClassNames } from 'utils/style';

const FooterWrap = styled.div.attrs(() => {
  const classNameToAdd = ['w-full', 'bg-basic-200', 'text-basic-700'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FooterElem = styled.div.attrs(() => {
  const classNameToAdd = ['w-11/12', 'break-words', 'md:w-full', 'container', 'mx-auto', 'py-1', 'text-basic-700'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FooterTop = styled.div.attrs(() => {
  const classNameToAdd = ['flex', 'justify-center', 'md:py-2'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FooterLogoAnchor = styled.a.attrs(() => {
  const classNameToAdd = ['cursor-pointer'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FooterContact = styled.div.attrs(({ isAccommodation }) => {
  const baseClassNames = ['w-full', 'text-sm', 'border-basic-300', 'lg:text-base', 'lg:flex'];
  const accClassNames = [...baseClassNames, 'py-8', 'lg:pb-4', 'border-t-2', 'border-b-2', 'lg:border-b-0'];
  const sfdClassNames = [...baseClassNames, 'pb-8', 'mb-2', 'border-b-2', 'lg:mb-5'];
  const classNamesToAdd = isAccommodation ? accClassNames : sfdClassNames;
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const FooterContactItem = styled.div.attrs(({ isAccommodation }) => {
  const baseClassNames = ['text-center', 'row-span-1', 'lg:w-1/3', 'w-full'];

  const sfdClassNames = [...baseClassNames, 'pb-8', 'mb-2', 'justify-center', 'border-b-2'];
  const classNamesToAdd = isAccommodation ? [...baseClassNames] : sfdClassNames;
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const FooterAddressItem = styled.a.attrs(({ isAccommodation }) => {
  const baseClassNames = ['text-center', 'row-span-1', 'lg:w-1/3', 'w-full'];

  const sfdClassNames = [...baseClassNames, 'pb-8', 'mb-2', 'justify-center', 'border-b-2'];
  const classNamesToAdd = isAccommodation ? [...baseClassNames] : sfdClassNames;
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const FooterSocialItems = styled.div.attrs(({ isAccommodation }) => {
  const baseClassNames = ['flex', 'justify-center', 'lg:w-1/3', 'w-full'];
  const accClassNames = [...baseClassNames, 'pt-6', 'lg:pt-0'];
  const sfdClassNames = [...baseClassNames, 'w-full'];
  const classNamesToAdd = isAccommodation ? accClassNames : sfdClassNames;
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const FooterContactEmphasis = styled.span.attrs(() => {
  const classNameToAdd = ['text-primary', 'pr-1'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FooterBottom = styled.div.attrs(() => {
  const classNameToAdd = [
    'w-full',
    'flex',
    'flex-col',
    'justify-center',
    'items-center',
    'text-sm',
    'pt-5',
    'pb-8',
    'lg:pt-0',
    'lg:pb-6',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const FooterNav = styled.div.attrs(() => {
  const classNameToAdd = ['w-full', 'pt-1', 'flex', 'flex-wrap', 'flex-rows', 'text-sm', 'justify-center'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})`
  a:last-child {
    border-right: 0;
  }
`;

const FooterAnchor = styled.a.attrs(() => {
  const classNameToAdd = [
    'transition-colors',
    'hover:opacity-80',
    'active:opacity-80',
    'duration-200',
    'ease-in-out',
    'cursor-pointer',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

export {
  FooterWrap,
  FooterTop,
  FooterLogoAnchor,
  FooterElem,
  FooterContact,
  FooterContactItem,
  FooterAddressItem,
  FooterContactEmphasis,
  FooterBottom,
  FooterNav,
  FooterAnchor,
  FooterSocialItems,
};
